<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading">{{ msg }}</h5>
    </b-alert>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            coeffRate: function () {
                return this.data.out.sop;
            },
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 1.57;
                        },
                        msg: 'Рекомендовано диетическое питание, направленное на снижение массы тела, и занятия лечебной физкультурой',
                        variant: 'primary'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 1.28, 1.57);
                        },
                        msg: 'Рекомендованы преимущественно кардиотренировки, направленные на снижение массы тела',
                        variant: 'warning'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 0.79, 1.28);
                        },
                        msg: 'Допускаются все типы тренировок',
                        variant: 'success'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 0.65, 0.79);
                        },
                        msg: 'Рекомендованы преимущественно силовые тренировки, направленные на набор массы тела',
                        variant: 'warning'
                    },
                    {
                        is: function (x) {
                            return x < 0.65;
                        },
                        msg: 'Рекомендовано диетическое питание, направленное на восполнение массы тела, и занятия лечебной физкультурой',
                        variant: 'primary'
                    }
                ]
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeffRate);
                });
            }
        }
    }
</script>